module.exports = __webpack_public_path__ + "images/trellis-logo.a305f292.png";